import I18n from '@module/i18n';

export function convertUploadTimeToText(remainingUploadTimeInSeconds) {
  if (
    !remainingUploadTimeInSeconds ||
    !Number.isFinite(remainingUploadTimeInSeconds)
  ) {
    return false;
  }

  let minutes = Math.ceil(remainingUploadTimeInSeconds / 60);
  if (minutes < 60) {
    // This is how the old monolith calculated minutes
    minutes = minutes < 1 ? 0 : Math.round(minutes);
    return I18n.t('transfer.progress.remaining.minutes', { count: minutes });
  }

  return I18n.t('transfer.progress.remaining.hours', {
    count: Math.round(minutes / 60),
  });
}
